module.exports = __webpack_public_path__ + "static/media/coolingIcon.b57f270a.svg";